export default __webpack_public_path__ + "img/in-afc17bc39f7b2796fddc2e3d5a3d87a1.png";